import axios from '@helper/Api/api';


const getTransactionsApi = (query) => axios.get(`/api/v1/odata/accounts/transactions${query}`, { headers: { authorization: 'Bearer ' + localStorage.getItem('token') } }).then(result => result.data)

export {
  getTransactionsApi,
}